export const messages = {
  en: {
    shopConfig: {
      basicSettings: 'Basic Settings',
      edit: 'Edit',
      businessStartTime: 'Business Start Time:',
      businessEndTime: 'Business End Time:',
      deliveryMethod: 'Delivery Method:',
      deliveryFee: 'Delivery Fee:',
      selfDelivery: 'Self Delivery',
      storeVerification: 'Store Verification',
      startTime: 'Start Time',
      endTime: 'End Time',
      inputStartTime: 'Please enter business start time',
      inputEndTime: 'Please enter business end time',
      selectDeliveryMethod: 'Please select delivery method',
      inputDeliveryFee: 'Please enter delivery fee',
      startTimeRequired: 'Business start time is required',
      endTimeRequired: 'Business end time is required',
      deliveryMethodRequired: 'Delivery method is required',
      deliveryFeeRequired: 'Delivery fee is required when select self delivery'
    }
  },
  zh: {
    shopConfig: {
      basicSettings: '基本设置',
      edit: '修改',
      businessStartTime: '营业开始时间：',
      businessEndTime: '营业结束时间：',
      deliveryMethod: '派送方式：',
      deliveryFee: '派送费：',
      selfDelivery: '自送',
      storeVerification: '到店核销',
      startTime: '开始时间',
      endTime: '结束时间',
      inputStartTime: '请填写营业开始时间',
      inputEndTime: '请填写营业结束时间',
      selectDeliveryMethod: '请选择配送方式',
      inputDeliveryFee: '请填写配送费',
      startTimeRequired: '营业开始时间不能为空',
      endTimeRequired: '营业结束时间不能为空',
      deliveryMethodRequired: '请选择配送方式',
      deliveryFeeRequired: '选择自送时配送费不能为空'
    }
  }
}